<template>
  <div
    class="tw-transition tw-rounded-3xl tw-flex tw-mb-2 tw-border tw-border-gray tw-text-dark dark:tw-text-dm-dark dark:tw-border-dm-gray tw-p-6 tw-flex tw-items-center tw-gap-5 hover:tw-shadow dark:hover:tw-shadow-dm hover:tw-border-transparent hover:tw-text-primary dark:hover:tw-text-dm-primary"
  >
    <div :style="`width: ${columnWidths.type}`">
      <a
        class="tw-font-medium tw-tracking-wide tw-leading-5"
        target="_blank"
        :href="`/foreigners/questionnaires/${questionnaire.id}`"
      >
        {{ questionnaire.survey_type_name }}
      </a>
    </div>
    <div :style="`width: ${columnWidths.status}`">
      <i-badge
        class="tw-w-fit"
        :type="questionnaire.completed ? 'success' : 'default'"
      >
        {{ questionnaire.completed ? 'Completed' : 'Not completed' }}
      </i-badge>
    </div>
    <div :style="`width: ${columnWidths.isSubmitted}`">
      <i-badge
        class="tw-w-fit"
        :type="questionnaire.submitted ? 'success' : 'default'"
      >
        {{ questionnaire.submitted ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { columnWidths } from './columns';

export default {
  components: {
  },

  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      foreigner: (state) => state.v2.foreigner.foreigner.foreigner,
    }),
    columnWidths: () => columnWidths,
  },

  watch: {
    'questionnaire.submitted': {
      immediate: true,
      handler(submitted) {
        this.submitted = submitted;
      },
    },
  },
};
</script>
